export default __webpack_public_path__ + "static/media/deepL-light.90b5ebfd.svg";